import axios from "axios";
import { API_URL } from "constants";

export const createSeries = async (formData, companyId) => {
  const url = `${API_URL}/${companyId}/series`;
  return axios.post(url, formData).then((response) => response.data);
};

export const updateSeries = async (formData, companyId) => {
  const url = `${API_URL}/${companyId}/series/${formData.id}`;
  return axios.patch(url, formData).then((response) => response.data);
};

/**
 * Sales invoice numbering registers.
 *
 * A different resource from `series` above, and deliberately so: that table
 * names files, contracts and fuel reports and is written by the Finvalda sync,
 * while these exist only to number sales invoices.
 */
export const fetchInvoiceSeries = async (companyId) => {
  const url = `${API_URL}/${companyId}/invoice-series`;
  return axios.get(url).then((response) => response.data);
};

export const createInvoiceSeries = async (companyId, payload) => {
  const url = `${API_URL}/${companyId}/invoice-series`;
  return axios.post(url, payload).then((response) => response.data);
};

/**
 * Sends ONLY the fields given. The settings screen never loaded the rest, and
 * a blanket update would post stale values over them.
 */
export const updateInvoiceSeries = async (companyId, seriesId, payload) => {
  const url = `${API_URL}/${companyId}/invoice-series/${seriesId}`;
  return axios.patch(url, payload).then((response) => response.data);
};

export const fetchSeries = async (companyId) => {
  const url = `${API_URL}/${companyId}/series`;
  return axios.get(url).then((response) => response.data);
};
